import React, { useEffect, useRef, useState } from 'react';
import { Input } from './ui/input';
import { API } from '../lib/api';

export const AddressLookupInput = ({
  value,
  onChange,
  onSelect,
  placeholder = 'Escribe una direccion'
}) => {
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    const onClickOutside = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  useEffect(() => {
    const query = (value || '').trim();
    if (query.length < 3) {
      setResults([]);
      setOpen(false);
      return;
    }

    const controller = new AbortController();
    const timeout = setTimeout(async () => {
      try {
        setLoading(true);
        const params = new URLSearchParams({ q: query });
        const response = await fetch(`${API}/geocode?${params.toString()}`, {
          signal: controller.signal,
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) {
          setResults([]);
          setOpen(false);
          return;
        }

        const data = await response.json();
        setResults(Array.isArray(data) ? data : []);
        setOpen(Array.isArray(data) && data.length > 0);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Address lookup failed:', error);
        }
        setResults([]);
        setOpen(false);
      } finally {
        setLoading(false);
      }
    }, 450);

    return () => {
      clearTimeout(timeout);
      controller.abort();
    };
  }, [value]);

  const handleSelect = (item) => {
    onChange(item.display_name);
    if (onSelect) {
      onSelect({
        address: item.display_name,
        latitude: Number(item.lat),
        longitude: Number(item.lon)
      });
    }
    setOpen(false);
  };

  return (
    <div className="relative" ref={rootRef}>
      <Input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
      />
      {loading && <p className="text-xs text-gray-500 mt-1">Buscando direcciones...</p>}

      {open && (
        <div className="absolute z-20 mt-1 w-full rounded-md border bg-white shadow-lg max-h-56 overflow-auto">
          {results.map((item) => (
            <button
              key={`${item.place_id}-${item.lat}-${item.lon}`}
              type="button"
              onClick={() => handleSelect(item)}
              className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50 border-b last:border-b-0"
            >
              {item.display_name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
